<template>
  <div class="enclosureAdd">
    <div-border label="选择人员">
      <el-form>
        <el-form-item label="选择部门：" label-width="130px" style="margin-top: 20px">
          <el-select v-model="department" filterable placeholder="请选择部门" size="mini" @change="depNameChange" value-key="id">
            <el-option v-for="(item,index) in departmentList" :label="item.name" :value="item.id" :key="`${index}rs`" ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div class="checkbox">
        <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
        <div style="margin: 15px 0;"></div>
        <el-checkbox-group v-model="checkedCities" @change="handleCheckedCitiesChange">
          <el-checkbox v-for="item in cities" :label="item" :key="item.name">{{item.name}}</el-checkbox>
        </el-checkbox-group>
      </div>
      <div style="display: flex;justify-content: center;margin-bottom: 20px">
        <el-button size="mini" class="searchBtn" @click="transmit">确认</el-button>
        <el-button class="resetBtn" size="mini" @click="dialogClose">关闭</el-button>
      </div>

    </div-border>
  </div>
</template>

<script>
  import divBorder from "@/components/divBorder";
  import {
    qryDepartment1
  }from "@/service/basicfile"
  import {
    empDeptListByEmpName1
  }from "@/service/audit"
    export default {
        name: "enclosureAdd",
      components:{
        divBorder
      },
      props:{
        depId: {
          type: String,
          default: ''
        },
        peopleList:{
          type: Object,
          default: ()=>{ return {} }
        }
      },

      data(){
          return{
            department:this.depId,
            departmentList:[{name:'全部',id:""}],
            isIndeterminate: true,
            checkAll: false,
            checkedCities: [],
            cities:[],
            departmentMap:new Map(),
          }
      },
      watch:{
        depId(newVal,oldVal){
          console.log(newVal)
          this.department = newVal
        },
      },
      mounted() {
          // this._qryDepartment()
      },
      methods:{
        async _qryDepartment(){
          let res =await qryDepartment1();
          //先初始化
          this.departmentList = [{name:'全部',id:""}]
          res.data.forEach((item)=>{
          this.departmentList.push({
            name:item.depNm,
            id:item.id
          })
            //保存 部门名称，id
            this.departmentMap.set(item.id,item.depNm)
          })
        },
        async depNameChange(val){
          this.checkedCities = [];
          let obj = {};
          if(val && val != '') {
            obj = {deptId:val};
          }
          let res =await empDeptListByEmpName1(obj);
          this.cities= res.data.map((item)=>{
            return{
              name:item.empNm,
              id:item.id
            }
          })
          // 判断 是否有值，回显
          if (this.peopleList > 1){
            this.checkedCities = this.peopleList.map(item=>{
              return{
                name:item.empName,
                id:item.empId
              }
            })
          }
        },
        handleCheckAllChange(val) {
          this.checkedCities = val ? this.cities : [];
          this.isIndeterminate = false;
        },
        handleCheckedCitiesChange(value) {
          let checkedCount = value.length;
          this.checkAll = checkedCount === this.cities.length;
          this.isIndeterminate = checkedCount > 0 && checkedCount < this.cities.length;
        },
        transmit(){
          let fileUserName=""
           let  fileUserId = ""
          //将 附件人姓名，id 通过id拼接
          this.checkedCities.forEach((item,index)=>{
            console.log(item)
            fileUserName +=  this.checkedCities.length-1 ===index ? item.name :item.name+","
            fileUserId +=  this.checkedCities.length-1 ===index ? item.id :item.id+","
            console.log(fileUserName)
          })
          let peopleList =this.checkedCities.map(item=>{
            return{
              empId:item.id,
              empName:item.name
            }
          })
          let data = {
            depId:this.department,
            fileUserName:fileUserName,
            fileUserId:fileUserId,
            peopleList:peopleList
          }
          //触发父组件 函数
          this.$emit('enclosureClick',data)
          this.checkedCities = ''
          this.isIndeterminate = true
          this.checkAll = false
        },
        dialogClose(){
          this.checkedCities = ''
          this.isIndeterminate = true
          this.checkAll = false
          this.department = ''
          this.$emit('eClose')
        }
      }
    }
</script>

<style lang="scss" scoped>
  .enclosureAdd{
    padding: 20px;
    .checkbox{
      padding: 0 49px;
      margin-bottom: 30px;
    }
    ::v-deep{
      .el-form-item__label{
        font-weight: 700;
      }
    }
  }
</style>
